/**
 * DocViewSchema for Stock Reconciliation DocType
 * 
 * Schema-driven layout for Stock Reconciliation detail pages.
 * 
 * Tab structure:
 * - Details: Stock reconciliation overview, details, items, and status
 * - Meta: System/audit fields
 * 
 * This schema replaces the legacy FormViewConfig approach.
 * All layout changes should be made in this file.
 */

import type { DocViewSchema } from "./types";

export const stockReconciliationDocViewSchema: DocViewSchema = {
  doctype: "Stock Reconciliation",
  views: {
    experience: {
      style: "shopify",
      
      // All sections available in this view
      sections: [
        // ===== Details Tab Sections =====
        {
          id: "stock-reconciliation-overview",
          label: "Stock Reconciliation Overview",
          description: "Stock Reconciliation identification and key status information",
          layout: "two-column",
          fields: [
            "name",
            "docstatus",
            "posting_date",
            "posting_time",
          ],
        },
        {
          id: "stock-reconciliation-details",
          label: "Stock Reconciliation Details",
          description: "Core stock reconciliation information",
          layout: "two-column",
          fields: [
            "company",
            "purpose",
            "expense_account",
            "cost_center",
            "remarks",
          ],
        },
        {
          id: "items",
          label: "Items",
          description: "Items being reconciled in this stock reconciliation",
          layout: "one-column",
          fields: [
            "items", // Child table (Stock Reconciliation Item)
          ],
        },
        {
          id: "status-summary",
          label: "Status Summary",
          description: "Stock Reconciliation status and document state",
          layout: "two-column",
          fields: [
            "docstatus",
          ],
        },
        
        // ===== Meta Tab Sections =====
        {
          id: "audit",
          label: "System Information",
          description: "Audit and system fields",
          layout: "two-column",
          fields: [
            "owner",
            "creation",
            "modified_by",
            "modified",
          ],
        },
      ],
      
      // Tab definitions - organize sections into navigation
      tabs: [
        {
          id: "details",
          label: "Details",
          sectionIds: ["stock-reconciliation-overview", "stock-reconciliation-details", "items", "status-summary"],
        },
        {
          id: "meta",
          label: "Meta",
          sectionIds: ["audit"],
        },
      ],
      
      // Quick actions available in header/toolbar
      // TODO: Implement these actions via Doc Actions DSL
      quickActions: [
        // "submit_stock_reconciliation",
        // "cancel_stock_reconciliation",
        // "duplicate_stock_reconciliation",
      ],
      
      // Connection groups for Connections tab
      connectionGroups: [
        "stock",
        "inventory",
      ],
    },
    
    // System view: minimal config, let meta drive the layout
    system: {
      sections: [
        {
          id: "all_fields",
          label: "All Fields",
          layout: "one-column",
          // Empty fields array = render all meta fields
        },
      ],
    },
  },
};

